<template>
	<v-card
		:style="isStyled"
		class="rating elevation-0"
	>
		<v-card-title class="rating__name">
			{{ rating.button_name || 'Rating' }}
		</v-card-title>
		<div class="rating__content d-flex justify-center">
			<v-rating
				color="#FFBC03"
				:size="isLessThan600 ? 22 : 40"
				:ripple="false"
				@input="rate"
				v-model="value"
				:hover="true"
			/>
		</div>
	</v-card>
</template>
<script>
import { mapActions } from 'vuex'
export default {
	props: {
		rating: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			value: 0,
		}
	},
	methods: {
		...mapActions('app', ['postRating']),
    handleRating(value) {
      switch (this.$route.name) {
        case 'speaker-by-id':
          this.$emit('handleTriggerSpeakerRating', value)
          break
        case 'event-by-id':
          this.$emit('eventRatingTrigger', value)
          break
        case 'event-session-by-id':
          this.$emit('handleTriggerRatingSession', value)
          break
        case 'exhibitor-by-id':
          this.$emit('handleTriggerExhibitorRating', value)
          break
      }
    },
		async rate() {
			await this.postRating({
				rating_entity_type: this.rating.rating_entity_type,
				rating_entity_id: this.rating.rating_entity_id,
				rating: this.value,
			})
      this.handleRating(this.value)
		},
	},
	computed: {
    isStyled() {
      return {background: this.isBackColor ? '#FFFFFF' : '#F3F3F6',
               border: this.isBackColor ? '1px solid #e2e2e2 !important' : '',}
    },
		isBackColor() {
			return this.$route.name === 'speaker-by-id' || this.$route.name === 'exhibitor-by-id'
		},
		isLessThan600() {
			return this.$vuetify.breakpoint.width <= 600
		},
	},
	watch: {},
	created() {
		if (this.rating.user_rating) {
			this.value = this.rating.user_rating
		}
	},
}
</script>
<style lang="scss">
.rating {
	padding: 12px;
	font-family: Inter, sans-serif;
	user-select: none;

	&__content {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
	}

	&__name {
		font-size: 16px;
		font-weight: 500;
    color: var(--username-category-title);
		line-height: 21.94px;
		padding: 0 !important;
		display: flex;
		justify-content: center;
	}

	&__total {
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: 0;
		color: #002855;

		@media (max-width: 480px) {
			font-size: 16px;
		}
	}

	&__count {
		font-family: Inter, sans-serif;
		font-weight: 500;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: right;
		color: #9b9b9b;

		@media (max-width: 480px) {
			font-size: 12px;
		}
	}

	.v-rating {
		display: flex;
		flex-wrap: nowrap;
		justify-content: center;
	}
	.v-rating .v-icon {
		padding: 0 !important;
	}

	.accent--text::before {
		color: #e2e2e2 !important;
	}
}
</style>
